import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import Gear from '../../partials/gear';
import { Link } from 'react-router';
import Card from './partials/card';

class Contact extends React.Component {
    state = {
        microTransac: false,
        contactEmailList: null
    }
    componentWillMount() {
        const { contactActions, contactEmailList } = this.props;
        if (!contactEmailList) this.setState({ microTransac: true }, () => {
            contactActions && contactActions.fetch();
        });
        else this.setState({ contactEmailList });
    }
    componentWillReceiveProps = nextProps => {
        const { contactEmailList } = nextProps;
        this.setState({ contactEmailList, microTransac: false });
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    render() {
        const { microTransac, contactEmailList } = this.state;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/dashboard" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">Contact Form</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={3} onLogout={this.logout} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix white">
                        {contactEmailList && contactEmailList.map((contact, i) => <Card key={i} index={i} contact={contact} />)}
                    </section>
                </div>
            </section>
        )
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/private/contact/index.js